import Autolinker from 'autolinker';

export default html => Autolinker.link(html, { className: 'clickable' });



// WEBPACK FOOTER //
// ./src/utils/generateHtmlText.js